import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {DataConfig} from '../../../shared/models/tabs-data';
import {Observable, Subscription} from 'rxjs';
import {MiscellaneousSiteForm} from '../../models/site-form';
import {SiteGetInfoService} from '../../services/site-get-info.service';
import {Router} from '@angular/router';

@Component({
  selector: 'storever-miscellaneous-edit',
  templateUrl: './miscellaneous-edit.component.html',
  styleUrls: ['./miscellaneous-edit.component.scss']
})
export class MiscellaneousEditComponent implements OnInit, OnDestroy {

  dataConfig: DataConfig;
  content: Observable<MiscellaneousSiteForm>;
  @Output() saveForm = new EventEmitter<Object>();
  private sub$: Subscription;
  private subscriptions = [];

  constructor(private siteGetInfoService: SiteGetInfoService , private router: Router) {
  }

  ngOnInit(): void {
    this.dataConfig.form.disable();
    this.content = this.dataConfig.content;
    this.content.subscribe(sub => {
      this.dataConfig.form.patchValue(sub);
    })
  }

  ngOnDestroy(): void {
    this.dataConfig.form.markAsPristine();
  }

  /**
   * - Value from FormGroup
   * - Update/patch part of the object
   * @param apiNames
   */
  save(apiNames: string[]): void {
    const resp = this.dataConfig.form.get(apiNames[1]).value;
    if (this.router.url.split('?')[0].search('multi') !== -1) {
      this.saveForm.emit({ type: 'multiSubscription' , api: apiNames, data: resp });
    }
    else if (this.router.url.split('?')[0].search('contracts') !== -1) {
      this.saveForm.emit({ type: 'contracts' , api: apiNames, data: resp });
    }
    else {
      this.saveForm.emit({ api: apiNames, data: resp });
    }
  }

  undo(formPath: string[]): void {
    this.dataConfig.form.get(formPath).reset();
    this.dataConfigContentPatchForm(formPath);
  }

  dataConfigContentPatchForm(formPath?: string[]): void {
    this.content = this.dataConfig.content;
    this.sub$ = this.content.subscribe(sub => {
      if (formPath) {
        this.dataConfig.form.get(formPath).patchValue(sub[formPath[0]]);
      } else {
        this.dataConfig.form.patchValue(sub);
      }
    });
    this.subscriptions.push(this.sub$);
  }

  get isStatusOff$(): Observable<boolean> {
    return this.siteGetInfoService.isStatusOff()
  }

}
